/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const keyResultSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  label: z.string(),
  objectiveId: z.int(),
  organizationId: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
